export type ClientShell = 'mobile' | 'pc';

const STORAGE_KEY = 'wavelink:client-shell';

export function getClientShell(): ClientShell {
  if (typeof localStorage === 'undefined') {
    return 'mobile';
  }
  return localStorage.getItem(STORAGE_KEY) === 'pc' ? 'pc' : 'mobile';
}

export function setClientShell(shell: ClientShell): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, shell);
}

/** 按客户端模式返回默认首页路径 */
export function getPathForClientShell(shell: ClientShell): string {
  return shell === 'pc' ? '/radio-remote' : '/';
}

/** 登录成功后应进入的默认路径（读 localStorage） */
export function getPostAuthPath(): string {
  return getPathForClientShell(getClientShell());
}
